const initializeTrackingConsent = () => {
    const $modal = $(".tracking-consent");

    console.log(window.cookieconsent);

    if (!$modal.length) {
        return;
    }

    const consented = $modal.hasClass("consented");

    if (consented === true) {
        return;
    }

    const acceptUrl = $modal.data("accept");
    const tokenName = $modal.data("tokenname");
    const token     = $modal.data("token");

    const sendConsent = (url, type) => {
        const postData      = {};

        postData[tokenName] = token;

        $.ajax({
            url,
            type: "POST",
            data: postData,
            success: (response) => {
            }
        });
    };

    const allCookiesConsent = window.cookieconsent && window.cookieconsent.privacyToolsCheckAllEnabled();

    if (!consented && allCookiesConsent) {
        sendConsent(acceptUrl);
    } else {
        $(document).on("click", "#privacytools-banner-consent [aria-label=Aceitar]", function () {
            sendConsent(acceptUrl, "event");
        });
    }
};

export default initializeTrackingConsent;
